<template>
  <div>
    <PageAllow controller="CloudPrintTemplates" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="6" md="4">
            <v-cascader
              v-model="selected"
              :label="$t('PrintTemplate.selectTemplate')"
              :hide-details="false"
              :items="templates"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <SearcherDistrict
              v-if="selected == 'order' || selected == 'order_label' || selected == 'distribution' || selected == 'distribution_label'"
              v-model="districtSelected"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2" align-self="center">
            <v-select
              v-if="!isLabel"
              v-model="cloudPrintPageSize"
              :label="$t('PrintTemplate.pageSize')"
              :items="$t('$print.cloudPageNames')"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" align-self="center">
            <v-row dense>
              <v-spacer />
              <v-btn small color="success" @click.stop="save()">
                <v-icon x-small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.save") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet class="design-opts transparent-background-color">
        <v-row dense class="ma-0">
          <v-spacer />
          <v-expansion-panels
            v-model="panels"
            multiple
            accordion
            readonly="readonly"
            :class="panels.length == 0 ? '' : 'design-panels'"
            :style="panels.length == 0 ? 'width: 64px' : ''"
          >
            <v-expansion-panel
              :class="panels.length == 0 ? 'transparent-background-color' : ''"
            >
              <v-expansion-panel-header class="py-0 ps-0">
                <v-tabs
                  v-show="panels.length == 1"
                  fixed-tabs
                  v-model="tab"
                  class="mx-1"
                  background-color="transparent"
                >
                  <v-tab
                    @click.stop="
                      tab = 0;
                      panels == [0] ? null : (panels = [0]);
                    "
                  >
                    {{ $t("PrintTemplate.basicInfo") }}
                  </v-tab>
                </v-tabs>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-show="panels.length == 1"
                      v-bind="attrs"
                      v-on="on"
                      text
                      class="pa-0 me-2"
                      :disabled="(typeof selected != 'string')"
                      @click.stop="dialog = true"
                    >
                      <v-icon>fa-code</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("PrintTemplate.sourceCode") }}</span>
                </v-tooltip>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mx-n6">
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-sheet class="px-1" v-if="print_template">
                      <v-textarea
                        v-model="templateMemo"
                        outlined
                        class="ma-1"
                        hide-details
                        :label="$t('PrintTemplate.memo')"
                      />
                      <span class="caption px-3">
                        {{ $t("PrintTemplate.settings.title") }}
                      </span>
<!--                      <v-divider />-->
<!--                      <v-checkbox-->
<!--                        v-model="templateSettings.table_head_repetitive"-->
<!--                        dense-->
<!--                        hide-details-->
<!--                        class="px-2"-->
<!--                        :true-value="1"-->
<!--                        :false-value="0"-->
<!--                        :label="-->
<!--                          $t('PrintTemplate.settings.tableHeadRepetitive')-->
<!--                        "-->
<!--                      />-->
                      <v-checkbox
                        v-model="auto_flg"
                        dense
                        hide-details
                        class="px-2"
                        :true-value="1"
                        :false-value="0"
                        :label="$t('cloudPrinterSetting.settings.auto_flg')"
                      />
                      <span
                        v-if="
                          auto_flg
                        "
                      >
                        <v-checkbox
                          v-if="selected != 'distribution' && selected != 'distribution_label'"
                          v-model="auto_type.afterNew"
                          dense
                          hide-details
                          class="ps-9 pe-2"
                          :true-value="1"
                          :false-value="0"
                          :label="
                          $t('cloudPrinterSetting.settings.after_new')
                        "
                        />
                        <v-checkbox
                          v-if="selected != 'stockOrderOut' && selected != 'stockOrderOut_label'"
                          v-model="auto_type.afterConfirm"
                          dense
                          hide-details
                          class="ps-9 pe-2"
                          :true-value="1"
                          :false-value="0"
                          :label="
                            $t('cloudPrinterSetting.settings.after_confirm')
                          "
                        />
                        <v-checkbox
                          v-model="auto_type.afterApprove"
                          dense
                          hide-details
                          class="ps-9 pe-2"
                          :true-value="1"
                          :false-value="0"
                          :label="
                            $t('cloudPrinterSetting.settings.after_approve')
                          "
                        />
                        <v-checkbox
                          v-if="selected == 'distribution' || selected == 'distribution_label'"
                          v-model="auto_type.afterOutStock"
                          dense
                          hide-details
                          class="ps-9 pe-2"
                          :true-value="1"
                          :false-value="0"
                          :label="
                            $t('cloudPrinterSetting.settings.after_outstock')
                          "
                        />
                      </span>
                      <SearcherCloudPrinters
                        v-model="print_template.cloud_printers"
                        no-label
                      />
                      <span class="caption">
                        {{ $t("cloudPrinterSetting.settings.printerHint") }}
                      </span>
                      <v-row
                        v-if="
                          print_template &&
                          print_template.id &&
                          print_template.districts_code != null
                        "
                        no-gutters
                        class="pe-2"
                      >
                        <v-spacer />
                        <v-btn outlined dark color="danger" @click.stop="del()">
                          <v-icon x-small class="pe-1">fa-</v-icon>
                          {{ $t("CRUD.delete") }}
                        </v-btn>
                      </v-row>
                    </v-sheet>
                  </v-tab-item>
                </v-tabs-items>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-sheet>

      <div class="design-content">
        <v-sheet
          id="printDemo"
          v-if="print_html"
          class="print-layout-container elevation-2 mb-1"
          :style="
            'width:' + this.printPageOptions[this.cloudPrintPageSize].width + 'px;'
          "
        >
          <div v-if="!isLabel" style="width: 80%; margin: 0px auto;padding-top: 30px" v-html="print_html"></div>
          <JsonViewer v-else :value="print_template.template" expanded />
        </v-sheet>
      </div>
    </v-sheet>

    <v-dialog v-model="dialog" max-width="1200px">
      <v-card>
        <v-card-title class="mx-3">
          <span class="d-inline-block text-truncate">
            {{ $t("PrintTemplate.sourceCode") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer">
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('PrintTemplate.sourceCode')"
              rules="json"
            >
              <v-textarea
                v-model="templateJSON"
                outlined
                rows="20"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" @click="saveSourceCode()">{{$t("CRUD.save")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
@media (max-width: 799px) {
  .design-content {
    margin-left: 16px;
    margin-right: 16px;
    overflow-x: scroll !important;
  }
  .design-opts {
    margin: 16px;
  }
  .design-panels {
    width: calc(100vw - 32px);
  }
}
@media (min-width: 800px) {
  .design-content {
    margin-left: 24px;
    margin-right: 24px;
    /* margin-right: 356px; */
    overflow-x: scroll !important;
  }
  .design-opts {
    position: absolute;
    right: 24px;
  }
  .design-panels {
    width: 320px;
  }
}
</style>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import VCascader from "@/components/plugins/VCascader";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import SearcherCloudPrinters from "@/components/plugins/SearcherCloudPrinters";
import sampleDistribution from "./sampleDatas/distribution";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import makeData from "../distributions/makeData";
import JsonViewer from "vue-json-viewer";

const defaultTemplate = [
  {
    type: "row",
    display_text: "打印模板",
    class: ["CB"]
  }
]

const defaultLabelTemplate = {
  direction: 0,
  detail_key: "order_details",
  columns: [
    {
      x: 2,
      y: 10,
      font: 12,
      w: 1,
      h: 1,
      r: 0,
      isDetail: 0,
      display_text: "打印模板"
    },
    {
      x: 2,
      y: 10,
      font: 12,
      w: 1,
      h: 1,
      r: 0,
      isDetail: 0,
      formater: "{0}配送单",
      field: "material_name",
    },
  ],
}



export default {
  components: {
    PageAllow,
    Breadcrumbs,
    VCascader,
    SearcherDistrict,
    ValidationObserver,
    ValidationProvider,
    SearcherCloudPrinters,
    JsonViewer,
  },

  data: () => ({
    panels: [0],
    dataPanels: [],
    tab: 0,
    dialog: false,
    selected: null,
    districtSelected: null,
    print_template: null,
    auto_flg: 0,
    auto_type:{
      afterNew: 0,
      afterConfirm: 0,
      afterApprove: 0,
    },
    print_html:null,
    templateMemo: "",
    templateJSON: null,
    templateJSONErrors: [],
    cloudPrintPageSize: i18n.t("$print.defaultCloudPageOption"),
    printPageOptions: i18n.t("$print.cloudPageOptions"),
    isLabel: false,
  }),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.printSetting"),
        disabled: false,
        href: "/settings/print-templates",
      },
      {
        text: i18n.t("SettingNav.reportDesign"),
        disabled: true,
        href: "/settings/print-templates",
      },
    ],
    templates: () => [
      {
        value: 1,
        text: "订货相关",
        children: [
          {
            value: "order",
            text: "要货单打印",
            // children: [],
          },
          {
            value: "order_label",
            text: "要货单打印(标签机)",
            // children: [],
          },
          {
            value: "distribution",
            text: "配送单打印",
            // children: [],
          },
          {
            value: "distribution_label",
            text: "配送单打印(标签机)",
            // children: [],
          },
        ],
      },
      {
        value: 2,
        text: "采购相关",
        children: [
          {
            value: "adminPurchase",
            text: "采购单打印",
            // children: [],
          },
          {
            value: "adminPurchase_label",
            text: "采购单打印(标签机)",
            // children: [],
          },
        ],
      },
      {
        value: 3,
        text: "仓库相关",
        children: [
          {
            value: 31,
            text: "入库相关",
            children: [
              {
                value: "stockOrderIn",
                text: "入库单打印",
                // children: [],
              },
              {
                value: "stockOrderIn_label",
                text: "入库单打印(标签机)",
                // children: [],
              },
            ],
          },
          {
            value: 32,
            text: "出库相关",
            children: [
              {
                value: "stockOrderOut",
                text: "出库单打印",
                // children: [],
              },
              {
                value: "stockOrderOut_label",
                text: "出库单打印(标签机)",
                // children: [],
              },
              {
                value: "shipStockOrderOut",
                text: "发货明细打印",
                // children: [],
              },
              {
                value: "shipStockOrderOut_label",
                text: "发货明细打印(标签机)",
                // children: [],
              },
              {
                value: "waitOutMaterialCount",
                text: "待出库打印",
                // children: [],
              },
              {
                value: "waitOutMaterialCount_label",
                text: "待出库打印(标签机)",
                // children: [],
              },
            ],
          },
        ],
      },
    ],
    sampleDatas() {
      return {
        distribution: makeData.processDetails(sampleDistribution.distribution),
        order: makeData.processDetails(sampleDistribution.order),
        adminPurchase: makeData.processDetails(sampleDistribution.adminPurchase),
      };
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([]),
  },

  watch: {
    selected: {
      handler() {
        if (typeof this.selected == "string" && this.selected.slice(-5) == 'label') {
          this.isLabel = true;
        }else {
          this.isLabel = false;
        }
        this.print_html = null;
        this.fetchTemplate();
      },
    },
    districtSelected: {
      handler() {
        this.print_html = null;
        this.fetchTemplate();
      },
    },
    cloudPrintPageSize: {
      immediate: true,
      handler() {
        this.$store.commit("cloudPrintPageSize", this.cloudPrintPageSize);
        localStorage.setItem("cloudPrintPageSize", this.cloudPrintPageSize);
        this.fetchTemplate();
      },
    },
    auto_flg: {
      handler() {
        if (!this.auto_flg) {
          this.auto_type = {
            afterNew: 0,
            afterConfirm: 0,
            afterApprove: 0,
          }
        }
      }
    }
  },

  methods: {
    fetchTemplate() {
      if (typeof this.selected == "string") {
        let postData = {
          print_template_code: this.selected,
          data: (this.sampleDatas[this.selected]) ? this.sampleDatas[this.selected] : [],
          maxStr: this.printPageOptions[this.cloudPrintPageSize].maxStr,
        }
        if (this.districtSelected) {
          postData.districts_code = this.districtSelected.code
        }
        CloudPrintTemplates.getPreviews(postData).then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.template) {
                this.print_template = response.data.template;
                this.templateJSON = response.data.template.template
                        ? JSON.stringify(response.data.template.template)
                        : null;
                this.templateMemo = response.data.template.memo;
                this.print_html = response.data.cloud_prints
                this.auto_flg = this.print_template.auto_flg;
                if (this.print_template.auto_type) {
                  this.auto_type = this.print_template.auto_type;
                }else {
                  this.auto_type = {
                    afterNew: 0,
                    afterConfirm: 0,
                    afterApprove: 0,
                  }
                }
              }else {
                // 新增打印模板
                this.print_template = {
                  print_template_code: this.selected,
                  districts_code: this.districtSelected
                          ? this.districtSelected.code
                          : null,
                  template: JSON.parse(JSON.stringify(this.isLabel ? defaultLabelTemplate : defaultTemplate)),
                };
                this.auto_flg = 0;
                this.auto_type = {
                  afterNew: 0,
                  afterConfirm: 0,
                  afterApprove: 0,
                }
                this.templateJSON = JSON.stringify(this.isLabel ? defaultLabelTemplate : defaultTemplate)
                this.templateMemo = "";
              }
            }
          }.bind(this)
        );
      }
      // else this.print_template = null;
    },
    del() {
      // 删除
      this.$store.dispatch("fullscreenLoading");
      CloudPrintTemplates.del(this.print_template.id)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              // 新增打印模板
              this.print_template = {
                print_template_code: this.selected,
                districts_code: this.districtSelected
                        ? this.districtSelected.code
                        : null,
                template: JSON.parse(JSON.stringify(this.isLabel ? defaultLabelTemplate : defaultTemplate)),
              };
              this.auto_flg = 0;
              this.auto_type = {
                afterNew: 0,
                afterConfirm: 0,
                afterApprove: 0,
              }
              this.templateJSON = JSON.stringify(this.isLabel ? defaultLabelTemplate : defaultTemplate)
              this.templateMemo = "";
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    save() {
      //普通保存
      this.$store.dispatch("fullscreenLoading");
      CloudPrintTemplates.save(
        this.print_template.id,
        Object.assign({}, this.print_template, {
          memo: this.templateMemo,
          auto_flg: this.auto_flg,
          auto_type: this.auto_type,
        })
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("cloudPrinterSetting.Messages.saveSuccess"));
              this.fetchTemplate();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    saveSourceCode() {
      //源代码模式保存
      this.$refs.observer.validate().then(
        function () {
          CloudPrintTemplates.save(
            this.print_template.id,
            Object.assign({}, this.print_template, {
              template: JSON.parse(this.templateJSON),
              memo: this.templateMemo,
              auto_flg: this.auto_flg,
              auto_type: this.auto_type,
            })
          ).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("cloudPrinterSetting.Messages.saveSuccess"));
                this.fetchTemplate();
                this.dialog = false;
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
  },
};
</script>
